import { Injectable, Type } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateTeamResponse } from '../../providers/bimplus-websdk/endpoint-adapters/teams/teams.interface';

@Injectable()
export abstract class TeamServiceStrategy<
  Team,
  C = CreateTeamResponse,
  SidebarInlineConfig = unknown,
> {
  abstract sidebarTitle: string;
  abstract sidebarInlineConfig: SidebarInlineConfig;
  abstract getTeams(): Observable<Team[]>;
  abstract hasOwnTeam(teams: Team[]): boolean;
  abstract createTeam(team: Team): Observable<C>;
  abstract findTeamById(teamId: string, teams: { id: string }[]): Team | undefined;
  abstract createTeamDialog(component: Type<unknown>, strategy: unknown): void;
  abstract loadSelectedTeam(): Team | null;
  abstract selectTeam(team: Team): void;
  abstract getTeamById(teamId: string): Observable<Team>;
  abstract getProjects(orgId: string): Observable<unknown[]>;
}
